(function () {
    document.addEventListener('DOMContentLoaded', function() {
        const scriptUrl = "/js2/sienna.min.js";

        const loadScript = (url) => {
            const script = document.createElement('script');
            script.src = url;
            document.body.appendChild(script);
        };

        loadScript(scriptUrl);

        const allyButtons = document.querySelectorAll('.ally-button');

        if (!allyButtons.length) {
            return;
        }

        allyButtons.forEach((el) => {
            el.addEventListener('click', function (event) {
                event.preventDefault();
                dataLayer.push({'event': 'ally_click'});

                const widgetButton = document.querySelector('.asw-menu-btn');
                if (!widgetButton) {
                    return;
                }
                widgetButton.click();
            });
        });
    });
})();
